import React, { createContext } from 'react';

const SessionContext = createContext({
  authenticationErrors: '',
  authenticationMethod: '',
  expiresOn: '',
  socialIssuer: '',
  roles: [],
  setClaims: () => {}
});

export default SessionContext;
